export default {
  toggleLoading(state, isLoading) {
    state.loading = isLoading;
  },
  toggleLoadingExporting(state, loadingExporting) {
    state.loadingExporting = loadingExporting;
  },
  toggleLoadingListStatus(state, loadingListStatus) {
    state.loadingListStatus = loadingListStatus;
  },
  toggleLoadingListSubStatus(state, loadingListSubStatus) {
    state.loadingListSubStatus = loadingListSubStatus;
  },
  toggleLoadingReprocess(state, loadingReprocess) {
    state.loadingReprocess = loadingReprocess;
  },
  toggleLoadingPayload(state, loadingPayload) {
    state.loadingPayload = loadingPayload;
  },
  setListStatus(state, listStatus) {
    state.listStatus = listStatus;
  },
  setListSubStatus(state, listSubStatus) {
    state.listSubStatus = listSubStatus;
  },
  setLogs(state, logs) {
    state.logs = logs;
  },
  setEvent(state, event) {
    state.event = event;
  },
  setLote(state, lote) {
    state.lote = lote;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/store/mutations.js